import { Flex, Text } from '@chakra-ui/react';

interface RemoveButtonProps {
  label: string;
  onClick: () => void;
  isDisabled?: boolean;
}

const RemoveButton = ({ label, onClick, isDisabled = false }: RemoveButtonProps) => (
  <Flex justify="flex-end">
    <Text
      as="span"
      fontSize="12px"
      color="alertRed"
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      opacity={isDisabled ? 0.5 : 1}
      onClick={isDisabled ? undefined : onClick}
      _hover={isDisabled ? undefined : { textDecoration: 'underline' }}
    >
      {label}
    </Text>
  </Flex>
);

export default RemoveButton;
